import { getData } from '../utils/data.js';
export const SimProvider = {
    Soracom: 'soracom',
    Once: '1nce',
};
export const SimExternalStatus = {
    SoracomReady: 'soracom:ready',
    SoracomActive: 'soracom:active',
    SoracomInactive: 'soracom:inactive',
    SoracomStandby: 'soracom:standby',
    SoracomSuspended: 'soracom:suspended',
    SoracomTerminated: 'soracom:terminated',
    OnceActive: '1nce:Enabled',
    OnceInactive: '1nce:Disabled',
};
export const SimExternalExpiryAction = {
    SoracomDoNothing: 'soracom:doNothing',
    SoracomDeleteSession: 'soracom:deleteSession',
    SoracomDeactivate: 'soracom:deactivate',
    SoracomSuspend: 'soracom:suspend',
    SoracomTerminate: 'soracom:terminate',
    SoracomNull: 'soracom:null',
};
export const SimConverter = {
    fromFirestore(snap, op) {
        return getData(snap, op);
    },
    toFirestore(d) {
        return d;
    },
};
export const getStatusForExternal = (status) => {
    const splitted = status.split(':');
    return {
        provider: splitted[0],
        status: splitted[1],
    };
};
export const getExpiryActionForExternal = (expiryAction) => {
    const splitted = expiryAction.split(':');
    return {
        provider: splitted[0],
        expiryAction: splitted[1],
    };
};
//# sourceMappingURL=sim.js.map